import {
    createNamespacedHelpers
} from "vuex";

export const riskCharts = {
    data() {
        return {
            timeout: null,
        };
    },
    methods: {
        alterRisk(x, y, yName, id, riskText, maxRisk) {
            try {
                let tickValues = [0, 1, 2, 3, 4, 5];
                let maxY = 5;
                if (maxRisk > 4) {
                    tickValues = [0, 1, 2, 3, 4, 5, 6];
                    maxY = 6;
                }
                let self = this;
                let Core = window["mbc-core"],
                    LineChart = window["mbc-line"],
                    generator = Core.Utils.generators;
                clearTimeout(self.timeout);
                self.timeout = setTimeout(() => {
                    let container = d3.select(id);
                    let newLineChart = LineChart.extend({
                        drawLine: function(data, index) {
                            var scales = this.get("scales");
                            var xScale = scales.scale("x");
                            var yScale = scales.scale("y1");
                            var y2Scale = scales.scale("y2");
                            var layer = this.get("canvas").layer("layer-lines" + index).attr("clip-path", "url(#" + this.get('clipPathId') + ")");
                            var group = data.groupName;
                            var isDotted = this.isDottedLine(group, data.displayName);
                            var color = data.color || this.color(index);
                            var agileStyle = this.get("agileStyle");
                            var xDomainLabels = this.get("xDomain");

                            var xoffset = xScale.rangeBand() / 2;

                            var generateLine = d3.svg.line()
                                .defined(function(d) {
                                    return d != null;
                                })
                                .x(function(d, i) {
                                    return xScale(xScale.domain()[d.x]) + xoffset;
                                })
                                .y(function(d) {
                                    return yScale(d.y);
                                }).interpolate("linear");

                            var generateY2Line = d3.svg.line()
                                .defined(function(d) {
                                    return d != null;
                                })
                                .x(function(d, i) {
                                    return xScale(xScale.domain()[i]) + xoffset;
                                })
                                .y(function(d) {
                                    return y2Scale(d);
                                }).interpolate("linear");

                            var lines = layer.selectAll(".line").data(xDomainLabels);
                            var series = data.series;
                            //generate new series points for greatwall line
                            var newSeries = [];
                            var lastRisk = series[series.length - 1];
                            var lastIndex = 0;
                            for (var i = series.length - 1; i > -1; i--) {
                                if (lastRisk != series[i]) {
                                    var newPoint = {};
                                    newPoint.y = series[i];
                                    newPoint.x = lastIndex;
                                    newSeries.push(newPoint);
                                }

                                var newPointOrgi = {};
                                newPointOrgi.y = series[i];
                                newPointOrgi.x = i
                                newSeries.push(newPointOrgi);

                                lastRisk = series[i];
                                lastIndex = i;
                            }

                            var linePath = group === "y2AxisData" ? generateY2Line(newSeries) : generateLine(newSeries);
                            lines.enter()
                                .append("path")
                                .classed("line", true)
                                .attrs({
                                    d: linePath,
                                    stroke: color,
                                    fill: "none",
                                    "shape-rendering": "auto",
                                    "stroke-dasharray": function() {
                                        return isDotted ? agileStyle.dottedDashDimensions : null;
                                    },
                                    "stroke-linecap": function() {
                                        return isDotted ? "round" : null;
                                    },
                                    "stroke-width": agileStyle.lineStrokeWidth
                                });
                            lines.exit().remove();
                        }
                    });
                    let chart = new newLineChart({
                            "y1TickSymbol": "",
                            "y2TickSymbol": "",
                            "xAxisOrient": "bottom",
                            "y1AxisOrient": "left",
                            "dottedLineNames": {
                                "y1AxisData": false,
                                "y2AxisData": false
                            },
                            "y2": false,
                            "legend": false,
                            "tooltip": true,
                            "tickValues": tickValues
                        }),
                        dataset = {
                            xDomain: x,
                            y1AxisData: [{
                                name: yName,
                                values: y,
                            }],
                            "y2AxisData": []
                        };

                    chart.__attributes.yDomain = [0, maxY]
                    container.datum(dataset).call(chart.init());
                    chart.getTooltipText = function(id, risk) {
                        return risk[id];
                    };

                    chart.__attributes.tooltipTemplate = chart.__attributes.tooltipTemplate.replace(
                        /this.data\[index\].value/g,
                        chart.getTooltipText +
                        "(this.datapoint," +
                        JSON.stringify(riskText) +
                        ")"
                    );

                    let uid = chart.get("UID");
                    d3.selectAll(
                        "." + uid + " .mbc-axis.mbc-axis-y1 .tick text"
                    ).each(function() {
                        this.textContent = "R" +
                            this.textContent
                            .replace(/.00/g, "")
                            .replace(/\$/g, "");
                        this.textContent = this.textContent.replace("R0", "").replace("R6", "");
                    });

                    d3.select("#svgcontainer_" + uid).style("display", "none");
                    let tickCount = (d3.selectAll(".mbc-axis.mbc-axis-x.mbc-axis-bottom .tick")[0]).length;
                    d3.selectAll(".mbc-axis.mbc-axis-x.mbc-axis-bottom .tick").each(function() {
                        if (tickCount > 10) {
                            let month = this.textContent.split("/")[0];
                            if (!(parseFloat(month) === 2 || parseFloat(month) === 5 || parseFloat(month) === 8 || parseFloat(month) === 11)) {
                                this.textContent = "";
                            }
                        }
                    });
                    d3.select(".background-bar-group")[0][0].textContent = "";
                    d3.select(".layer-dots0").remove();
                    // let i = 0;
                    // let lineDotCount = (d3.selectAll(".lineDot")[0]).length - 1;
                    // d3.selectAll(".lineDot").each(function() {
                    //     if (i != 0 && i != lineDotCount) {
                    //         d3.select(this).remove();
                    //     }
                    //     i++;
                    // })
                }, 200);
            } catch (err) {
                console.log(err);
            }
        },
    },
};
